import ReqClient from './request.class'

// 创建推广计划
export async function creatCampaign (data) {
  const Req = new ReqClient({
    url: '/api/uc/campaign/create/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告组
export async function getCampaign (data) {
  const Req = new ReqClient({
    url: '/api/uc/campaign/get/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新广告组
export async function uploadCampaign (data) {
  const Req = new ReqClient({
    url: '/api/uc/campaign/update/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加推广单元（第一步）
export async function addAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/uc/ad/addcaohuaplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加推广单元（第二步）
export async function creatAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/uc/ad/addUcplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取推广单元详情
export async function getAdgroup (params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryByAdIdAndMediaId',
    params: {
      ad_account_id: params.account,
      ad_id: params.id
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新推广计划
export async function updateAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/uc/ad/updateUcplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取人群包
export async function getAudience (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getAudience',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 判断单元是否有创意
export async function hasCreative (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/hasCreative',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取转化列表
export async function getConvert (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getAdConvert',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// UC获取有效的转化列表
export async function getConvertType (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getConvertType',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 验证爬虫是否工作
export async function isSpiderWork (data) {
  const Req = new ReqClient({
    url: '/api/uc/adConvert/isSpiderWork',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取推荐列表
export async function getRecomment (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getRecomment',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 检查是否需要首次联调
export async function checkConvert (data) {
  const Req = new ReqClient({
    url: '/api/uc/adConvert/check',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取该用户审核通过的词包
export async function getWildcardIds (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getWordPackage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户上传的图片
export async function getImagesByAccount (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getImage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户上传的视频
export async function getVideosByAccount (params) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getVideo',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传本地图片
export async function uploadLocalImage (params) {
  const Req = new ReqClient({
    url: '/api/uc/material/uploadLocal',
    timeout: 300000,
    params: {
      ad_account_id: params.account,
      file: params.file
    }
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建创意
export async function creatCreative (data) {
  const Req = new ReqClient({
    url: '/api/uc/creative/create/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改自定义创意
export async function uploadCreative (params) {
  const Req = new ReqClient({
    url: '/api/uc/creative/update',
    data: params,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 修改程序化创意
export async function updateProceduralCreative (params) {
  const Req = new ReqClient({
    url: '/api/uc/creative/updateProceduralCreative',
    data: params,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询创意详情
export async function getCreative (data) {
  const Req = new ReqClient({
    url: '/api/uc/creative/getCreativeByCreativeId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据计划查询创意详情
export async function getCreativeByAdId (data) {
  const Req = new ReqClient({
    url: '/api/uc/creative/getCreativeByAdgroupId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改创意详情
export async function editCreative (data) {
  const Req = new ReqClient({
    url: '/api/uc/creative/update/',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取人群包
export async function getRecommentUC (data) {
  const Req = new ReqClient({
    url: '/api/uc/tool/getRecomment',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改提交任务
export async function updatePlanTaskById (data) {
  const Req = new ReqClient({
    url: '/api/ptom/ptomBatch/updateUcAdPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
